import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import CSSModules from 'helpers/CSSModulesUtil'
import { List } from 'react-toolbox/lib/list'

import Body from 'components/typography/body1/index'
import ListItem from './ListItem'
import { compose, branch, renderComponent } from 'recompose'

import styles from './styles.scss'

const withStyle = CSSModules(styles)

const SubstituteList = ({ substitutes, ...rest }) => {
  return (
    <List>
      {
        substitutes.map((substitute) => (
          <ListItem
            {...rest}
            substitute={substitute}
            key={substitute.username}
          />
        ))
      }
    </List>
  )
}
const EmptySubstituteList = () => {
  return (
    <div styleName='emptyList'>
      <Body>You have no substitutes</Body>
    </div>
  )
}

export default compose(
  branch(
    R.pathEq(['substitutes', 'length'], 0),
    renderComponent(withStyle(EmptySubstituteList))
  ),
  withStyle
)(SubstituteList)
